import {
  RecruitingEmploymentContractType,
  type RecruitingEmploymentContractType as RecruitingEmploymentContractTypeType,
} from '@flex-apis/recruiting';

export function isRecruitingEmploymentContractType(
  status: unknown
): status is RecruitingEmploymentContractTypeType {
  return Object.values(RecruitingEmploymentContractType).some(
    item => item === status
  );
}
